import { AnimatePresence, motion } from 'framer-motion';

export default function AnimatedHeader({ title, subtitle, currentPhase }) {
  return (
    <div style={{ minHeight: '120px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
      <AnimatePresence mode="wait">
        <motion.div
          key={currentPhase} // Força remontagem quando a fase muda
          style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
        >
          {/* Título */}
          <motion.span
            className="white-title"
            initial={{ opacity: 0, y: -20 }}
            animate={{
              opacity: 1,
              y: 0,
              transition: { duration: 0.4, delay: 0 }
            }}
            exit={{
              opacity: 0,
              y: 20,
              transition: { duration: 0.3, delay: 0 }
            }}
          >
            {title}
          </motion.span>

          {/* Subtítulo */}
          <motion.span
            className="white-subtitle"
            initial={{ opacity: 0, y: -20 }}
            animate={{
              opacity: 1,
              y: 0,
              transition: { duration: 0.4, delay: 0.7 }
            }}
            exit={{
              opacity: 0,
              y: 20,
              transition: { duration: 0.3, delay: 0 }
            }}
          >
            {subtitle}
          </motion.span>
        </motion.div>
      </AnimatePresence>
    </div>
  );
}

